module.exports = __webpack_public_path__ + "img/l2.a1c5f65d.png";